module.exports = __webpack_public_path__ + "img/hero_typo_only.e039ac47.png";